import Icon from '../components/Icon.vue'

Icon.register({
  'comment-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M448 0c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64h-144l-124.9 93.7c-7.9 5.8-19.1 0.1-19.1-9.7v-84h-96c-35.3 0-64-28.7-64-64v-288c0-35.3 28.7-64 64-64h384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comment-alt.js
// module id = 1223
// module chunks = 0